export { default as EngagementScoreFullWidth } from "./EngagementScoreFullWidth"
export { default as LengthOfService } from "./LengthOfService"
export { default as NineBoxGridLarge } from "./NineBoxGridLarge"
export { default as NineBoxGridSmall } from "./NineBoxGridSmall"
export { default as RiskOfLeaving } from "./RiskOfLeaving"
export { default as LabourTurnover } from "./LabourTurnover"
export { default as RiskOfLeavingBar } from "./RiskOfLeavingBar"
export { default as LengthOfServiceAverage } from "./LengthOfServiceAverage"
export { default as TotalEmployees } from "./TotalEmployees"
export { default as LabourTurnoverOverall } from "./LabourTurnoverOverall"
export { default as HappyScale } from "./HappyScale"
export { default as ChallengesFaced } from "./ChallengesFaced"
export { default as DirectReports } from "./DirectReports"
export { default as ReadyToMove } from "./ReadyToMove"
export { default as GoalStatusBreakdown } from "./GoalStatusBreakdown"
export { default as ReviewAgreement } from "./ReviewAgreement"
export { default as TemperatureCheckScores } from "./TemperatureCheckScores"
export { default as Top5LD } from "./Top5LD"
export { default as DoingWell } from "./DoingWell"
export { default as NeedImproving } from "./NeedImproving"
export { default as EngagementScoreLineChart } from "./EngagementScoreLineChart"
export { default as EngagementScoreDoughnut } from "./EngagementScoreDoughnut"
export { default as PerformanceScoreDoughnut } from "./PerformanceScoreDoughnut"
export { default as EmployeeNetPromotorScoreDoughnut } from "./EmployeeNetPromotorScoreDoughnut"
export { default as AgreedLAndDCompleted } from "./AgreedLAndDCompleted"
export { default as OverallBehaviourAverageDoughnut } from "./OverallBehaviourAverageDoughnut"
export { default as GoalScoreDoughnut } from "./GoalScoreDoughnut"
export { default as NumberOfLogins } from "./NumberOfLogins"
export { default as LeaversInFirst100Days } from "./LeaversInFirst100Days"
export { default as TemperatureCheckResponseRate } from "./TemperatureCheckResponseRate"
export { default as CoffeeChatsCompleted } from "./CoffeeChatsCompleted"
export { default as PersonCard } from "./PersonCard"
export { default as Freedom } from "./Freedom"
export { default as MeetingNeeds } from "./MeetingNeeds"
export { default as CustomNPS } from "./CustomNPS/CustomNPS"
export { default as PerformanceComparison } from "./PerformanceComparison"
export { default as TopUsedFeatures } from "./TopUsedFeatures"
export { default as PulseChecks } from "./PulseChecks"
export { default as TotalEmployeesBar } from "./TotalEmployeesBar"
export { default as BehavioursBreakdown } from "./BehavioursBreakdown"
export { default as Completion } from "./Completion"
export { default as ValueAlignment } from "./ValueAlignment"
export { default as Journeys } from "./Journeys"



// WEBPACK FOOTER //
// ./src/components/widgets/index.js